    import React, { Fragment } from 'react'
    import { Toast } from 'antd-mobile'
    import cx from 'classnames'
    import { goIndex } from '@/assets/js/utils'

    function GeneralButton ({ data, buriedPointEvent }) {
        let { id, position, sublist = [], style = {}, trackId } = data
        if (!style) style = {}
        let { textColor, backgroundColor, backgroundPicUrl, backgroundImage } = style
        /**
        * 样式:这块的逻辑和吸底按钮保持一致, 要求接口报文数据结构和吸底按钮一致
        */
        if (!backgroundColor && !backgroundPicUrl) {
            backgroundImage = 'linear-gradient(100deg, #F4E1B7 0%, #DAB37C 100%)'
        } else if (!backgroundColor && backgroundPicUrl) {
            backgroundImage = `url(${backgroundPicUrl})`
        }
        return (
            <Fragment>
                {sublist.map((item, index) => (
                    <div
                        style={{
                            backgroundColor,
                            backgroundImage,
                            color: textColor || '#fff',
                            width: '10rem',
                            height: 98 / 75 + 'rem',
                            lineHeight: 98 / 75 + 'rem'
                        }}
                        onClick={() => {
                            buriedPointEvent({
                                button_name: `${trackId}-${item.title}`,
                                button_id: `${item.id}`,
                                button_order: `${index + 1}`,
                                area_order: position,
                                button_area: `${position}-${trackId}`
                            })
                            if (item.urlType === '4') {
                                const input = document.createElement('input')
                                document.body.appendChild(input)
                                input.setAttribute('readonly', 'readonly')
                                input.setAttribute('value', item.title)
                                input.focus() // 选择对象
                                input.setSelectionRange(0, 9999)

                                // 执行浏览器复制命令
                                if (document.execCommand('copy')) {
                                    document.execCommand('copy')
                                    Toast.info(`已为您复制"${item.title}"公众号,正在跳转微信`, 1)
                                    setTimeout(() => {
                                        window.location.href = item.url
                                    }, 800)
                                } else {
                                    Toast.info('复制失败', 1)
                                }
                                document.body.removeChild(input)
                            } else {
                                goIndex(item.url, trackId, item.keyword, item)
                            }
                        }}
                        key={id}
                        className={cx('submit-btn statistics-dom', 'statistics-dom')}
                    >
                        {item.buttonText || '关注公众号'}
                    </div>
                ))}
            </Fragment>
        )
    }

    export default GeneralButton
